import React from 'react';
import { useParams } from 'react-router-dom';

export const withRouteParams = BaseComponent => ({ ...props }: { [key: string]: any }) => {
  const routeParams = useParams<{ [key: string]: string }>();
  return <BaseComponent {...routeParams} {...props} />;
};
